"use client";

import { Analytics as VercelAnalytics } from "@vercel/analytics/react";
import { useEffect } from "react";
import { env } from "@/lib/env";
import { initWebVitals } from "@/lib/performance/web-vitals";

export function Analytics() {
  const isVercelAnalyticsEnabled =
    env.NEXT_PUBLIC_ENABLE_VERCEL_INSIGHTS === true;

  useEffect(() => {
    if (!isVercelAnalyticsEnabled) return;

    // Initialize web vitals monitoring
    if (typeof window !== "undefined") {
      initWebVitals();
    }
  }, [isVercelAnalyticsEnabled]);

  if (!isVercelAnalyticsEnabled) return null;

  return <VercelAnalytics />;
}
